import React from "react"
import styles from './FormGroup.module.scss';
import classNames from "classnames";
import { InputError } from "./InputError";
import { ConditionalRender } from "@/components/ConditionalRender";

interface SelectOptions extends React.OptionHTMLAttributes<HTMLOptionElement> {
  text: string;
}

interface FormGroupProps extends React.PropsWithChildren {
  label: React.LabelHTMLAttributes<HTMLLabelElement> & { text: string };
  input?: React.InputHTMLAttributes<HTMLInputElement>;
  textArea?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
  select?: React.SelectHTMLAttributes<HTMLSelectElement>;
  selectOptions?: SelectOptions[];
  error?: string;
}

export const FormGroup: React.FC<FormGroupProps> = (props) => {
  const {
    label,
    input,
    textArea,
    select,
    selectOptions,
    error,
    children,
  } = props;

  const { text: labelText, ...labelRest } = label;

  const required = input?.required || select?.required || textArea?.required;

  return (
    <div className={styles.FormGroup}>
      <label
        {...labelRest}
        className={classNames(labelRest.className, {
          [styles.error]: error,
        })}
      >
        <span dangerouslySetInnerHTML={{ __html: labelText }} />
        <ConditionalRender condition={required}>
          <span className="obrigatorio">*</span>
        </ConditionalRender>
      </label>

      <ConditionalRender condition={children}>
        {children}
      </ConditionalRender>

      <ConditionalRender condition={input}>
        <input
          {...input}
          type={input?.type || 'text'}
          className={classNames(input?.className, {
            [styles.error]: error,
          })}
        />
      </ConditionalRender>

      <ConditionalRender condition={select}>
        <select
          {...select}
          className={classNames(select?.className, {
            [styles.error]: error,
          })}
        >
          {selectOptions && selectOptions.map((selectOption, index) => {
            const { text, ...optionRest } = selectOption;
            return (
              <option key={`${select?.name}-${text}-${index}`} {...optionRest}>
                {text}
              </option>
            )
          })}
        </select>
      </ConditionalRender>

      <ConditionalRender condition={textArea}>
        <textarea
          {...textArea}
          className={classNames(textArea?.className, {
            [styles.error]: error,
          })}
        />
      </ConditionalRender>

      <ConditionalRender condition={error}>
        <InputError text={error} />
      </ConditionalRender>
    </div>
  )
}